import React from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
function PopSendMail(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_mail">
      <h2 className="pop_tit">메일 보내기</h2>
      <div className="content_container scroll">
        <section className="search search_top">
          <select className="select">
            <option value="가길동">가길동</option>
            <option value="나길동">나길동</option>
          </select>
          <button className="com_btn gray ws xs icon_search"></button>
        </section>
        <ul className="com_input_sec">
          <li className="tit_field">받는사람</li>
          <li className="input_field">
            <div className="recipients_list line">
              <button className="item">
                가길동<span className="btn_del_file"></span>
              </button>
              <button className="item">
                나길동<span className="btn_del_file"></span>
              </button>
              <button className="item">
                다길동<span className="btn_del_file"></span>
              </button>
            </div>
          </li>
          <li className="tit_field">받는 부서</li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <select className="select full">
                <option value="가길동">가길동</option>
                <option value="나길동">나길동</option>
              </select>
              <button className="com_btn gray xs">+ 추가</button>
            </div>
          </li>
          <li className="input_field">
            <div className="recipients_list">
              <button className="item">
                부서명<span className="btn_del_file"></span>
              </button>
            </div>
          </li>
          <li className="tit_field">제목</li>
          <li className="input_field">
            <input type="text" className="input" placeholder="제목을 입력해주세요" />
          </li>
          <li className="input_field">
            <textarea className="textarea" placeholder="내용 입력"></textarea>
          </li>
        </ul>
        <div className="com_input_upload">
          <Upload title="파일 찾기" className="com_btn gray xs wl" />
          <p className="file">
            <span className="txt">File name.pdf</span>
            <button type="button" className="btn_del_file" onClick={() => {}}></button>
          </p>
        </div>
      </div>
      <hr className="com_divider type_inner" />
      <div className="btn_container">
        <button className="com_btn orange xs">보내기</button>
      </div>
    </Modal>
  );
}

export default PopSendMail;
